import React, { useState, useEffect, useCallback } from "react";
import _ from 'lodash';
import {
  Container, Label, Button, FormGroup,
  Modal, ModalHeader, ModalBody, ModalFooter, Input,
} from "reactstrap";
import {
  Row,
  Col,
  Table,
} from "reactstrap";
import ApiCaller from "../../../../../api/apiCaller";
import "./index.css";

interface ConfirmBuildingInputProps {
  buildingId?: number | null,
}

const ConfirmBuilding = ({ buildingId }:ConfirmBuildingInputProps) => {
  const [buildingData, setBuildingData] = useState<any | null>(null);

  const getBuildingData = async () => {
    const res = await ApiCaller.get(
      `location/${buildingId}`
    );
    console.log(res);
    if (res?.result) {
      setBuildingData(res.result);
    }
  };

  useEffect(() => {
    getBuildingData();
  }, []);

  return (
    <div>
      <p>Bạn sẽ tạo mặt bằng trong tòa nhà</p>
      {buildingData &&
        <div className="confirm-building-modal__building">
          <h4 className="confirm-building-modal__building-name">{buildingData.name}</h4>
          <p className="confirm-building-modal__building-address">{buildingData.full_address}</p>
        </div>
      }
    </div>
  )
}

export default ConfirmBuilding;